import React, { useState, useEffect } from 'react';
import './getpanverify.css';

const RepayLoan = () => {

  const [mobile, setMobile] = useState('');
  const [refStr, setRefStr] = useState('');
  const [responseMsg, setResponseMsg] = useState('');

  useEffect(() => {

    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (token) {

      try {

        const decoded = atob(token);
        const parts = decoded.split('|');

        if (parts.length === 2) {
          setRefStr(parts[0]);   // lead_id
          setMobile(parts[1]);   // PAN autofill
        }

      } catch (e) {
        console.error("Token decode error:", e);
      }

    }

  }, []);


  const handleSearch = async (e) => {

    e.preventDefault();

    try {

      const apiUrl =
        `https://fundswalla.in/Api/TaskApi/getLeadInfo?lead_id=${refStr}&pan_number=${mobile}`;

      const res = await fetch(apiUrl);
      const text = await res.text();

      console.log("API Response:", text);

      setResponseMsg(text);

    } catch (error) {

      console.error("Error fetching API:", error);
      setResponseMsg("Something went wrong while verifying PAN.");

    }

  };


  return (

    <div className="repay-loan-page">

      <section className="hero-section text-white text-center py-3">
        <div className="container">
          <h1 className="fw-bold">PAN Verification</h1>
        </div>
      </section>

      <section className="container mt-5">

        <form
          onSubmit={handleSearch}
          className="d-flex flex-column flex-md-row align-items-md-center gap-3 mb-4"
        >

          <input
  type="text"
  className="form-control"
  placeholder="Enter Your PAN Number"
  value={mobile}
  readOnly
  maxLength="10"
  required
/>
          <input type="hidden" name="lead_id" value={refStr} />

          <button type="submit" className="btn custom-submit-btn">
            Submit
          </button>

        </form>


        {responseMsg && (

          (() => {

            try {

              const parsed = JSON.parse(responseMsg);
              console.log("Parsed Response:", parsed);

             if (parsed.status === true) {

return (

<div className="text-center mt-4">

<div className="success-icon mb-3">

<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#28a745" strokeWidth="2">
<circle cx="12" cy="12" r="10"></circle>
<path d="M9 12l2 2 4-4"></path>
</svg>

</div>

<h4 className="text-success fw-bold mb-2">
Verification Successful!
</h4>

<p className="text-muted" style={{ fontSize:'16px', maxWidth:'400px', margin:'0 auto' }}>
Your PAN has been successfully verified.
</p>


{parsed.data && (

<div className="mt-4 d-flex justify-content-center">

<table className="table table-bordered" style={{maxWidth:"600px"}}>

<tbody>

<tr>
<td><b>Full Name</b></td>
<td>{parsed.data.fullName}</td>
</tr>

<tr>
<td><b>First Name</b></td>
<td>{parsed.data.firstName}</td>
</tr>

<tr>
<td><b>Last Name</b></td>
<td>{parsed.data.lastName}</td>
</tr>

<tr>
<td><b>PAN</b></td>
<td>{parsed.data.pan}</td>
</tr>

<tr>
<td><b>Date of Birth</b></td>
<td>{parsed.data.dob}</td>
</tr>

<tr>
<td><b>Gender</b></td>
<td>{parsed.data.gender}</td>
</tr>

<tr>
<td><b>Aadhaar Linked</b></td>
<td>{parsed.data.aadhaarLinked}</td>
</tr>

<tr>
<td><b>Masked Aadhaar</b></td>
<td>{parsed.data.maskedAadhaarNumber}</td>
</tr>

<tr>
<td><b>Address</b></td>
<td>{parsed.data.address}</td>
</tr>

</tbody>

</table>

</div>

)}

</div>

);


              } else {

                return (

                  <div className="text-center mt-4">

                    <div className="error-icon mb-3">

                      <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#dc3545" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="15" y1="9" x2="9" y2="15"></line>
                        <line x1="9" y1="9" x2="15" y2="15"></line>
                      </svg>

                    </div>

                    <h4 className="text-danger fw-bold mb-2">
                      Verification Failed!
                    </h4>

                    <p className="text-muted" style={{ fontSize: '16px', maxWidth: '400px', margin: '0 auto' }}>
                      The PAN number you entered is invalid or does not match our records. Please check and try again.
                    </p>

                  </div>

                );

              }

            } catch (e) {}

            return (

              <div className="alert alert-info mt-3">
                <div dangerouslySetInnerHTML={{ __html: responseMsg }} />
              </div>

            );

          })()

        )}

      </section>

    </div>

  );

};

export default RepayLoan;